module.exports = __webpack_public_path__ + "fonts/bergentext.392ef2c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/bergentext/bergentext.ttf
// module id = 312
// module chunks = 245 246